export const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

export const addToNestedObject = (obj: any, path: string[], value: any) => {
  let current = obj;
  for (let i = 0; i < path.length - 1; i++) {
    if (!current[path[i]]) {
      current[path[i]] = {};
    }
    current = current[path[i]];
  }
  current[path[path.length - 1]] = value;
};

export const isEmptyObject = <T extends object>(obj: T): boolean => {
  return getKeys(obj).length === 0;
};
